import { http } from 'vue'

export default {
  getChatMessages (context, params = {}) {
    return http.get('rpr_chat_messages?rent_pre_registration_chat_id=' + params.chatId)
  },
  saveChatMessages (context, params = {}) {
    return http.post('rpr_chat_messages', params.data)
  },
  updateChatMessages (context, params = {}) {
    return http.put('rpr_chat_messages/' + params.messageId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rent_pre_registration_chat_message/actions.js